"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const global_1 = require("../api/global");
const context_1 = require("./context");
const processor_1 = require("./processor");
(0, global_1.registerGlobal)('contextManager', new context_1.BrowserLogContextManager());
(0, global_1.registerGlobal)('processorProvider', new processor_1.BrowserLogEntryProcessorProvider());
tslib_1.__exportStar(require("../api"), exports);
//# sourceMappingURL=index.js.map